"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigation = require("../navigation");

var DefaultNavigation = function DefaultNavigation(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.Drawer, null), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.HamburgerMenu, null), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BrandLogo, null)), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.CenterAlign, null), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.RightAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.SupportMode, null), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.AccountBox, null))), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children));
};

DefaultNavigation.propTypes = {
  children: _propTypes["default"].element
};
var _default = DefaultNavigation;
exports["default"] = _default;